import { memo } from 'react';
import { OfferScoreChart } from '../../OfferScorecard/OfferScore/OfferScoreChart';
import { useBuyerOfferAnalysisContext } from '../Context/BuyerOfferAnalysisContext';

interface OfferScoreGaugeProps {
  size?: 'sm' | 'md' | 'lg';
  maskColor?: string;
}

export const OfferScoreGauge = memo(function OfferScoreGauge({
  size = 'md',
  maskColor = 'opaque.indigo_800_whiteAlpha_100',
}: OfferScoreGaugeProps) {
  const { offerScore, isCalculatingOfferScore } =
    useBuyerOfferAnalysisContext();

  return (
    <OfferScoreChart
      loading={isCalculatingOfferScore}
      maskColor={maskColor}
      score={
        offerScore.__typename === 'OfferScore' ? offerScore.value : undefined
      }
      size={size}
    />
  );
});
